module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (14).8eddccab.jpg";